import {
  MembersContactabilityStatus,
  QueryCheckMembersContactabilityArgs,
} from '@tribeplatform/gql-client/types'

import { UseQueryOptions, useQuery } from '../../index.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getCheckMembersContactabilityKey } from '../../utils/keys/messaging.key.js'

export const useCheckMembersContactability = (options: {
  variables: QueryCheckMembersContactabilityArgs
  useQueryOptions?: UseQueryOptions<MembersContactabilityStatus>
}) => {
  const { variables, useQueryOptions } = options

  const { client } = useTribeClient()
  const checkMembersContactabilityKey = getCheckMembersContactabilityKey({
    variables,
  })

  return useQuery<MembersContactabilityStatus>(
    checkMembersContactabilityKey,
    () => client.messaging.checkMembersContactability(variables),
    useQueryOptions,
  )
}
